import { useState, useEffect } from 'react';

interface Breakpoints {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

export function useBreakpoint(): Breakpoints {
  const [breakpoints, setBreakpoints] = useState<Breakpoints>(() => compute());

  useEffect(() => {
    const mqMobile = window.matchMedia('(max-width: 767px)');
    const mqDesktop = window.matchMedia('(min-width: 1024px)');

    const update = () => setBreakpoints(compute());

    mqMobile.addEventListener('change', update);
    mqDesktop.addEventListener('change', update);
    return () => {
      mqMobile.removeEventListener('change', update);
      mqDesktop.removeEventListener('change', update);
    };
  }, []);

  return breakpoints;
}

function compute(): Breakpoints {
  const w = window.innerWidth;
  return {
    isMobile: w < 768,
    isTablet: w >= 768 && w < 1024,
    isDesktop: w >= 1024,
  };
}
